module.exports = __webpack_public_path__ + "img/classify3.5094084.png";